import React from 'react';

const PulseEffect = () => {
  return (
    <div className="w-full h-full relative overflow-hidden flex items-center justify-center">
      <div className="relative flex items-center justify-center">
        <div
          className="absolute w-64 h-64 border-2 border-[#00FFD1] rounded-full opacity-20"
          style={{
            animation: 'pulse 4s ease-in-out infinite'
          }}
        />
        <div
          className="absolute w-48 h-48 border-2 border-[#00FFD1] rounded-full opacity-30"
          style={{
            animation: 'pulse 4s ease-in-out infinite',
            animationDelay: '1s'
          }}
        />
        <div
          className="absolute w-32 h-32 border-2 border-[#00FFD1] rounded-full opacity-40"
          style={{
            animation: 'pulse 4s ease-in-out infinite',
            animationDelay: '2s'
          }}
        />
        <div
          className="w-16 h-16 bg-[#00FFD1] rounded-full opacity-20"
          style={{
            boxShadow: '0 0 60px rgba(0, 255, 209, 0.4)',
            animation: 'centerGlow 3s ease-in-out infinite'
          }}
        />
      </div>
    </div>
  );
};

export default PulseEffect;